import { FC, useEffect } from 'react'
import Column from '@components/column'
import CardHeading from '@commons/headings/card'
import Fields from '@components/fields'
import ChooseSpecializations from '@commons/specializations'
import { StyleFormGrid } from './style'
import { Constant } from '@utils'
import { useSelector } from 'react-redux'
import { Category } from '@apis'
interface InstutitionProfileDetailsProps {
  setFieldValue?: any
  errors?: any
  values?: any
  disabled?: boolean
}
const InstutitionProfileDetails: FC<InstutitionProfileDetailsProps> = ({
  setFieldValue,
  errors,
  values,
  disabled = false,
}) => {
  const { data: departments } = useSelector((state: any) => state.departments)
  const fetchDepartments = async () => {
    await Category.list({
      state: 'departments',
      params: {
        type: 'Department',
      },
    }).catch(() => {})
  }

  useEffect(() => {
    if (!departments?.length) {
      fetchDepartments()
    }
  }, [])
  return (
    <Column rowGap={20}>
      <Column styleColumn="border-radius:8px;padding:20px;" bg="white">
        <Column styleColumn="margin-bottom:30px;">
          <CardHeading title="Personal Information" />
        </Column>
        <StyleFormGrid>
          <Fields.Input
            name="name"
            placeholder="Full Name"
            label="Full Name"
            disabled={disabled}
          />
          <Fields.Input
            type="email"
            name="email"
            placeholder="Email"
            label="Email"
            disabled={disabled}
          />
          <Fields.PhoneInput
            name="phoneNo"
            placeholder="Phone No"
            label="Phone No"
            disabled={disabled}
          />
          <Fields.Input
            name="address"
            placeholder="Address"
            label="Address"
            disabled={disabled}
          />
          <Fields.Input
            type="number"
            name="yos"
            placeholder="Year of Service"
            label="Year of Service"
            disabled={disabled}
          />
          <Fields.DropDown
            options={Constant.instituteTypes}
            titleAsKey="label"
            valueAsKey="value"
            placeholder="Select Institute Type"
            label="Institute Type"
            name="instituteType"
          />
          <Fields.DropDown
            options={departments}
            titleAsKey="name"
            valueAsKey="id"
            name="departments"
            placeholder="Select Department"
            label="Department"
            disabled={disabled}
            isMultiple
            hasSearch
          />
          <ChooseSpecializations
            disabled={disabled}
            isError={errors?.specializations}
            selectedItems={values?.specializations}
            onChange={(item: any) => {
              const findIndex = values?.specializations?.findIndex(
                (selected: any) => selected?.id == item.id,
              )
              if (findIndex >= 0) {
                setFieldValue(
                  'specializations',
                  values?.specializations?.filter(
                    (symptom) => symptom?.id != item?.id,
                  ),
                )
              } else {
                setFieldValue('specializations', [
                  ...values?.specializations,
                  item,
                ])
              }
            }}
          />
          <Fields.Map
            name="serviceArea"
            label="Delivery Range"
            placeholder="Delivery Range"
          />
        </StyleFormGrid>
      </Column>
      <Column styleColumn="border-radius:8px;padding:20px;" bg="white">
        <CardHeading title="Services Provided By Institute:" />
        <Column styleColumn="margin-top:20px;">
          <Fields.GroupCheckBox
            name="serviceIncludes"
            options={Constant.services}
            titleAsKey="label"
            valueAsKey="value"
          />
        </Column>
      </Column>
    </Column>
  )
}

export default InstutitionProfileDetails
